// https://github.com/lit/lit-element/issues/553
import { LitElement, html } from 'lit'
import { property, state} from 'lit/decorators.js'
import { EventsHandler } from './events-handler'

export class RaygunElement extends LitElement {

  refs = {}
  slotMap = new Map()
  eventsHandler = new EventsHandler()

  @property({ type: String })
  name = ''

  @property({ type: String })
  id = ''

  @property({ type: String })
  ref = ''


  @state({ type: String })
  scopeId = ''

  @state({ type: Boolean })
  useScopeAttribute = false

  createRenderRoot() {
    this.scopeId = `id-${this.uid()}`
    if (this.useScopeAttribute) {
      this.setAttribute(this.scopeId, '')
    }
    return this
  }

  uid(a) {
    return a ? (a ^ Math.random() * 16 >> a/4).toString(16)
    : ([1e1] + 1e1 + 1e1).replace(/[01]/g, this.uid)
  }

  registerEvents() {
    return {}
  }

  rebindEvents() {
    this.eventsHandler.setDefaultContext(this)
    this.eventsHandler.initEvents(this.registerEvents())
    this.eventsHandler.bindAll()
  }

  connectedCallback() {
    this.rebindEvents()
    super.connectedCallback()
  }

  disconnectedCallback() {
    this.eventsHandler.unbindAll()
    super.disconnectedCallback()
  }

  getChildNodes() {
    let nodes = [];
    let child = this.firstChild
    while (child) {
      nodes.push(child)
      child = child.nextSibling
    }
    return nodes
  }

  getAttributeSlot(element) {
    let name;
    if (element.getAttribute) {
      name = element.getAttribute('slot')
    }
    return name || '';
  }

  removeAttribute(element, name) {
    if (element.removeAttribute) {
      element.removeAttribute(name)
    }
  }

  saveSlots() {
    this.getChildNodes().forEach((child) => {
      const name = this.getAttributeSlot(child)
      if (!this.slotMap.has(name)) {
        this.removeAttribute(child, 'slot')
        child.parentElement.removeChild(child)
        this.slotMap.set(name, [])
      }
      const slot = this.slotMap.get(name)
      slot.push(child)
    })
  }

  querySlot(selector, slotName = '') {
    const all = this.slotMap.get(slotName)
    return all.filter(el => el.matches ? el.matches(selector) : false)
  }

  slot(slot = '', defaultContent = []) {
    const slotContent = this.slotMap.get(slot)
    return slotContent ? slotContent : defaultContent
  }

  captureRefs() {
    this.refs = {}
    this.querySelectorAll('[ref]').forEach((el) => {
      const name = el.getAttribute('ref')
      this.refs[name] = el
    })
  }

  update(changedProperties) {
    if (!this.hasUpdated) {
      this.saveSlots()
    }
    super.update(changedProperties)
    this.captureRefs()
  }

  render() {
    return html`
      ${this.slot()}
    `
  }
}
